

import { useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import {useSelector } from "react-redux";

import { Link, useLocation } from "react-router-dom";
import { Close, ReportGmailerrorred } from "@mui/icons-material";


const WarningStatus=()=>{
    
    const {openStatus,closeStatus,isStatusOpen}=useGlobalContext();
    const {statusCount}=useSelector(state=>state.p.admin)
    
   
    return <div  onClick={closeStatus} className={`modal-overlay ${isStatusOpen&&'show-modal'} `}>
        <div className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <h4 style={{display:'flex',gap:'8px',alignItems:'center'}}><ReportGmailerrorred fontSize="large"/>شما {statusCount} هشدار جدید دارید</h4>
            </div>
           <Link onClick={openStatus} to={{ pathname: '/Status',search:'fromDash', state: { fromDash:true } }} style={{width:'100%'}}>
           <button  className="EditMOdalBtnForm" >
            مشاهده
        </button>
           </Link>
        
        </div>

    </div>
}
export default WarningStatus